import { useTranslation } from "react-i18next";
import { useToast } from "../../modules/layout/components/ToastContext";
import { useState } from "react";
import { update } from "../_request";
import { useNavigate } from "react-router-dom";

interface ResetPasswordProps {
  targetProfileId: string;
}

export default function ResetPassword({ targetProfileId }: ResetPasswordProps) {

    const { t } = useTranslation();
    const { showToast } = useToast();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [password, setPassword] = useState("");
    const [ open, setOpen ] = useState(false);
    
    const handleResetPassword = async () => {
        if (!targetProfileId) {
            showToast?.(t("Profile id is missing"), "error");
            return;
        }
        try {
            setLoading(true);

            const url = `/api/UserEvents/resetpassword?targetProfileId=${encodeURIComponent(targetProfileId)}`;

            const result: any = await update(url, "");
            const respStatus = result?.status ?? result?.response?.status;

            if (respStatus === 200 || respStatus === 204 || respStatus === undefined) {
                showToast?.(t("Temporarypasswordwasresetsuccessfully"), "success", { persistent: true });
                setPassword("");
                return;
            }

            if (respStatus === 401) {
                navigate("/auth/login");
                return;
            }

            if (respStatus === 403) {
                navigate("/error/403");
                return;
            }

            if (respStatus === 404) {
                showToast?.(t("ProfileNotFound"), "error");
                return;
            }

            if (respStatus === 500) {
                navigate("/error/500");
                return;
            }

            showToast?.(
            t("StatusCode", { code: String(respStatus) }),
            "error"
            );
        } catch (err) {
            console.error(err);
            showToast?.(t("Failed to reset password"), "error");
        } finally {
            setLoading(false);
            setOpen(false);
        }
    };


    return (
        <>
            <button className="btn gg-btn me-2" onClick={() => setOpen(true)}>
                {t('ResetPass')}
            </button>

            {open && (
                <div className="gg-modal-overlay">
                    <div className="gg-modal">
                        <div className="gg-modal-header">
                            <h5 className=" mb-0">
                                {t('GeneratePass')}
                            </h5>
                        </div>

                        <div className="gg-modal-body">
                            <p className="text-muted small mb-0">
                                 {t('PassReset')}
                            </p>
                        </div>

                        <div className="gg-modal-footer">
                            <button
                                className="gg-btn"
                                onClick={() => setOpen(false)}
                                disabled={loading}
                            >
                                {t('Cancel')}
                            </button>

                            <button className="btn btn-secondary text-white"
                                    onClick={handleResetPassword}
                                    disabled={loading}
                                    >
                                    {loading ? t("Processing...") : t("ResetPass")}
                            </button>
                        </div>
                    </div>
                </div>
            )}  
    
        </>
    );
}
